import queryString from 'query-string';

const queryStringOptions = { arrayFormat: 'bracket', parseNumbers: true, parseBooleans: true };

export const queryStringUtils = {
  getQueryParams(options = {}) {
    options = { ...queryStringOptions, ...options };
    return queryString.parse(this.searchUrl(), options);
  },

  getQueryParam(name, options = {}) {
    return this.getQueryParams(options)[name];
  },

  searchUrl() {
    return window.location.search;
  },

  baseUrl() {
    return `${window.location.origin}${window.location.pathname}`;
  },

  buildParams(queryParams, options = {}) {
    const formatOptions = { ...queryStringOptions, ...options };
    return queryString.stringify(queryParams, formatOptions);
  },
};
